import React from "react";
import "./header.css";
import "./headerResponsiveStyleSheet.css";
import Logo from "../../Assets/Images/Logos/logo.svg"
import {Link} from "react-router-dom";
import {slide as Menu} from "react-burger-menu";
import Button from "../BasicComponents/Button";
import Icon from "../../Assets/IconLibrary/Icon";
import {DefaultParameters} from "../../Api/ApiCallMethod";

export default class Header extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            contactUsPopup: false,
            openBurgerMenu: false,
            activeMenu: "Features",
            menuList: [
                {
                    Name: "Security",
                    Route: "security",
                    RouteName: "security",
                    Availability: true,
                    isActive: false,
                },
                {
                    Name: "Use Cases",
                    Route: "ai-ip-use-cases",
                    RouteName: "ai-ip-use-cases",
                    Availability: true,
                    isActive: false,
                },
                {
                    Name: "Pricing",
                    Route: "pricing",
                    RouteName: "pricing",
                    Availability: true,
                    isActive: false,
                },
                {
                    Name: "Blogs",
                    Route: "blogs",
                    RouteName: "blogs",
                    Availability: true,
                    isActive: false,
                },
                {
                    Name: "Company",
                    Route: "company",
                    RouteName: "company",
                    Availability: true,
                    isActive: false,
                },
            ]
        }
    }


    login = () => {
        let productUrl = DefaultParameters().ProductURL
        productUrl += DefaultParameters().LoginRoute
        window.open(productUrl, '_blank');

    }


    requestDemo = () => {
        window.open("https://calendly.com/ipagentai", "_blank")
    }


    onChangeRoute = (activeMenu) =>{
        this.setState({
            activeMenu,
            openBurgerMenu: false,
        })
        let {scrollToTop, resetInfo} = this.props;
        scrollToTop();
        resetInfo();

    }

    render() {
        let {backgroundColor, scrollToTop} = this.props;
        let currentURL = window.location.href;
        let urlArray = currentURL.split("/");
        let lastURL = urlArray[urlArray.length - 1]; // for active design
        let {menuList} = this.state;
        return (
            <div className="main-header-container" style={{backgroundColor: backgroundColor}}>
                <div className="main-header">
                    <div className="main-header--left">
                        <Link to={"/"} className="main-header-logo" onClick={this.onChangeRoute.bind(this, "")}>
                            <img src={Logo} alt={"IP Agent Logo"} width={"100%"}/>
                        </Link>
                    </div>
                    <div className="main-header--right">
                        <div className="main-header-menu-list">
                            {
                                menuList.map((res,index)=>
                                    <Link to={"/"+res.Route} key={index}
                                          onClick={this.onChangeRoute.bind(this, res.Route)}>
                                        <div className={res.RouteName === lastURL ? "header-text main-menu active":"main-menu"}>
                                            {res.Name}

                                        </div>
                                    </Link>
                                )
                            }
                            <Button type={"secondary"} onClick={this.login.bind(this)}>
                                Free Trial
                            </Button>
                            <Button type={"primary"} onClick={this.requestDemo.bind(this)}>
                                Request Demo
                            </Button>
                        </div>
                        <div className="main-header-burger-menu-button">
                            <Menu right isOpen={this.state.openBurgerMenu}
                                  style={{height: "100vh"}}
                                  onOpen={()=>this.setState({openBurgerMenu: true})}
                                  onClose={()=>this.setState({openBurgerMenu: false})}>
                                <div className='burger-main-menu-list'>
                                    <Link to={"/"} className="burger-logo-container" onClick={scrollToTop}>
                                        <div className='logo-burger-division'>
                                            <img src={Logo} className="logo"
                                                 alt={"IP Agent AI Logo"}
                                                 width={"100%"} height={40}/>
                                        </div>
                                        <button className="logo-close-btn" onClick={()=>this.setState({openBurgerMenu: false})}>
                                            <Icon name="close" colorList={["white"]}/>
                                        </button>
                                    </Link>


                                    <div className="logo-burger-menu-list">
                                        {
                                            menuList.map((menu,index)=>
                                                <Link key={index}
                                                      onClick={this.onChangeRoute.bind(this, menu.Route, lastURL)}
                                                      className={menu.RouteName === lastURL?"main-menu active":"main-menu" }
                                                      to={"/"+menu.Route}>{menu.Name}</Link>
                                            )
                                        }




                                    </div>
                                    <div className='burger-menu-button-row'>
                                        <Button type="secondary" width={"170px"} height="40px" onClick={this.login.bind(this)}>Login</Button>
                                        <Button type="primary" width={"170px"} height="40px" onClick={this.requestDemo.bind(this)}>Request Demo</Button>
                                    </div>

                                </div>
                            </Menu>
                        </div>
                    </div>
                </div>


            </div>
        );
    }

}